import { useState, useRef } from 'react';
import { getTimeFromFormat } from 'utils/3catinfo/dateHelper';
import Imatge from 'components/3catinfo/Imatge';
import Player from 'components/3catinfo/Player';
import Icona from 'components/3catinfo/ui/Icona';
import Boto from 'components/3catinfo/Boto/Boto';
import LoadingPlayer from 'components/3catinfo/Players/LoadingPlayer';
import __get from 'lodash/get';
import clsx from 'clsx';
import styles from './playerpodcast.module.scss';

const PlayerPodcast = (props) => {
    const { id, titol, imatges, durada, className, priorityImage, numColumnsRow, programa, testId, showLabelPodcast } = props;
    const uniquePlayerId = useRef(Date.now()).current;
    const playerVideoTagId = `media-principal-audio-${id}`;
    const stylesPodcast = clsx({
        [styles.podcastdiari]: true,
        [styles[`numColumns-${numColumnsRow}`]]: true,
        [className]: !!className
    });

    const [playerVisible, setPlayerVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [titolPodcast, setTitolPodcast] = useState(titol);
    const [duradaPodcast, setDuradaPodcast] = useState(durada);
    const [imatge, setImatge] = useState(imatges);
    const playerRef = useRef();

    const pushMediaModel = (response) => {
        if (!titolPodcast) setTitolPodcast(__get(response, 'attributes.informacio.attributes.titol'));
        if (!imatge) {
            let imatgeMedia = __get(response, 'attributes.keyframes.models[0].attributes');
            if (imatgeMedia) {
                imatgeMedia.text = imatgeMedia?.url;
                setImatge([imatgeMedia]);
            }
        }
        if (!duradaPodcast) setDuradaPodcast(__get(response, 'attributes.informacio.attributes.durada.attributes.text'));
    };

    const playerControllerInstance = (playerController) => {
        playerController.on('loadedmetadata', () => {
            setIsLoading(false);
        });
    };
    const stylesInfoPodcast = clsx({
        [styles.infoWrapper]: true,
        [styles.infoContent]: true,
        [styles.hidden]: playerVisible
    });

    const stylesPlayerPodcast = clsx({
        [styles.podcast]: true,
        [styles.hidden]: !playerVisible || isLoading
    });

    return (
        <article className={stylesPodcast} data-testid={testId}>
            <div className={styles.imatgeWrapper}>
                {imatges && (
                    <Imatge
                        imatges={imatges}
                        className={styles.imatge}
                        tipus='web_playerpodcast'
                        aria-hidden='true'
                        layout='fill'
                        objectFit='cover'
                        crop='1903'
                        data_testid='destacat-img'
                        priority={priorityImage}
                        numColumnsRow={numColumnsRow}
                    />
                )}
            </div>
            <div className={styles.content}>
                <div className={styles.textContent}>
                    {showLabelPodcast && <h3 className={styles.programa}>Pòdcast</h3>}
                    <div className={styles.titol} data-testid='destacat-titol'>
                        {titol}
                    </div>
                </div>
                <div className={stylesInfoPodcast}>
                    <div className={styles.durada}>
                        <Icona
                            className={styles.ico_clock}
                            mida={24}
                            icona='rellotge'
                            isBlanc={true}
                            alt='Temps'
                            ariaHidden={true}
                        />
                        {durada && <span className={styles.minuts}>{getTimeFromFormat(durada)}</span>}
                    </div>
                    <div className={styles.filler}></div>
                    <Boto
                        className={styles.botoEscoltaAra}
                        text='Escolta-ho ara'
                        tag='button'
                        icona='auriculars_ple'
                        altIcona=''
                        iconaInline={true}
                        onClick={() => {
                            setPlayerVisible(true);
                            playerRef?.current?.play();
                        }}
                        fons='fonsContenidorNegre'
                        data_testid='destacat-boto'
                    />
                </div>
            </div>
            {playerVisible && (
                <>
                    {isLoading && <LoadingPlayer numColumnsRow={numColumnsRow} />}
                    <div className={stylesPlayerPodcast}>
                        <Player
                            ref={playerRef}
                            playerVideoTagId={`id-${uniquePlayerId}-${playerVideoTagId}`}
                            id={id}
                            autoPlay={true}
                            directe={false}
                            tipus='audio'
                            estils='audioPodcast'
                            imatges={imatge}
                            pushMediaModel={pushMediaModel}
                            playerControllerInstance={playerControllerInstance}
                            mostrarBotonsAccessibilitat={false}
                            eliminarPrimerTabIndex={true}
                        ></Player>
                    </div>
                    {!isLoading && programa && (
                        <div className={styles.contentBotoEpisodis}>
                            <Boto
                                className={styles.botoEpisodis}
                                text='Més àudios del programa'
                                estil='lined'
                                tema='secondary'
                                icona='fletxa_simple_dreta'
                                altIcona=''
                                isIconaBlanc={true}
                                iconaInline={true}
                                fons='fonsContenidorNegre'
                                linkTipus='web_3cat_programa'
                                slug={programa}
                            />
                        </div>
                    )}
                </>
            )}
        </article>
    );
};

PlayerPodcast.defaultProps = {
    showLabelPodcast: true
};

export default PlayerPodcast;
